import { getSafeRedirectPath } from './safeRedirect.js'

// sessionStorage survives the cross-origin round-trip to Kinde and back;
// router state and the URL query do not (KindeLogin strips the query before
// autoLogin, and Kinde only returns to the fixed /callback URI).
const STORAGE_KEY = 'postLoginRedirect'

/**
 * Stash the destination to restore after login. Validated on write AND on
 * read — the value transits sessionStorage, which other code (or an XSS'd
 * sibling tab) could scribble on.
 */
export function savePostLoginRedirect(path) {
  const safe = getSafeRedirectPath(path)
  if (safe) {
    sessionStorage.setItem(STORAGE_KEY, safe)
  }
}

/**
 * Read the stashed destination without clearing it — for flows that may or
 * may not leave this origin (the IMC cross-tenant hop).
 */
export function peekPostLoginRedirect() {
  return getSafeRedirectPath(sessionStorage.getItem(STORAGE_KEY))
}

/**
 * One-shot read: consuming clears the stash so a later, unrelated login
 * cannot replay a stale destination.
 */
export function consumePostLoginRedirect() {
  const safe = peekPostLoginRedirect()
  clearPostLoginRedirect()
  return safe
}

export function clearPostLoginRedirect() {
  sessionStorage.removeItem(STORAGE_KEY)
}
